import { Offer } from 'graphql/models/extended';

export enum PositionField {
  NUMBER = 'NUMBER',
  DESCRIPTION = 'DESCRIPTION',
  QUANTITY = 'QUANTITY',
  PRICING = 'PRICING',
  DIMENSION = 'DIMENSION',
  CUSTOM_DIMENSION = 'CUSTOM_DIMENSION',
  DIRECTION = 'DIRECTION',
  TZ = 'TZ',
}

export interface PositionUpdateInput {
  key: PositionField;
  value: any;
  dimensionKey?: string;
}

export interface PositionUpdate {
  offer: Offer;
  input: PositionUpdateInput;
}

export enum LineSubtypePropVal {
  FREE_ARTICLE = 'FreeArticle',
  MY_ARTICLE = 'MyArticle',
  LOOSE_ARTICLE = 'LooseArticle',
  PRODUCT = 'Configurable'
}
